const formatCurrency = (value, precision = 2) => {
  if (value === null ||
    value === undefined ||
    value === '') return null

  return '$' + parseFloat(value).toFixed(precision).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export default formatCurrency
